

















































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Location from '@/services/Location';
import LocationService from '@/services/LocationService';
import {required, between, decimal, helpers, minLength, maxLength } from 'vuelidate/lib/validators';
import { State } from 'vuex-class';
import { RuleDecl } from 'vue/types/options';
import states from '@/services/states';
import GeocodeService from '@/services/external/GeocodeService';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';

const zip = helpers.regex('zip', /^\d{5}(-\d{4})?$/);

@Component({})
export default class GeneralInfo extends Vue {
	@State('location') location!: Location;
	locationSvc = new LocationService(this.$store);
	geocodeSvc = new GeocodeService();
	states = states;
	images: string[] = [];
	loadingCoordinates = false;

	removeTag (item: string) {
		this.location.tags.splice(this.location.tags.indexOf(item), 1)
		this.location.tags = [...this.location.tags]
	}

	validations(): RuleDecl {
		return {
			location: {
				address1: {
					required
				},
				city: {
					required
				},
				state: {
					required,
					minLength: minLength(2),
					maxLength: maxLength(2)
				},
				zip : {
					required,
					zip: zip
				},
				latitude: {
					required,
					decimal,
					range: between(-90, 90)
				},
				longitude: {
					required,
					decimal,
					range: between(-180, 180)
				}
			}
		}
	}

	get branchImage(): string|null {
		return this.location.branchImage || null;
	}

	set branchImage(value: string|null) {
		this.location.branchImage = value || null;
	}

	get branchImageDisplayNone(): string {
		if (!this.location.id) {
			return 'Select One';
		}
		return 'Not Selected';
	}

	get stateErrors() {
		if (this.$v.location.state?.$error) {
			return 'Please complete this field.';
		}
		return this.$v.location.state?.$invalid && this.$v.location.state?.$model !== null ? 'Please complete this field.' : ''
	}

	get zipErrors() {
		if (this.$v.location.zip?.$anyError || (this.$v.location.zip?.$invalid && this.$v.location.zip?.$model !== null)) {
			if (!this.$v.location.zip?.required) {
				return 'Please complete this field.';
			}
			if (!this.$v.location.zip?.zip) {
				return 'Zip or Zip +4 is accepted.'
			}
		} 
		return [];
	}

	get address1Error() {
		return this.$v.location.address1?.$invalid;
	}
	get cityError() {
		return this.$v.location.city?.$invalid;
	}
	get stateError() {
		return this.$v.location.state?.$invalid;
	}
	get zipError() {
		return this.$v.location.zip?.$invalid;
	}

	get longErrors() {
		if(this.$v.location.longitude?.$error){
			if(!this.$v.location.longitude?.required){
				return 'Coordinates are required.';
			}
			if(this.$v.location.longitude?.$invalid){
				return 'Please enter coordinates in accepted format.';
			}
		}
		return null;
	}

	get latErrors() {
		if(this.$v.location.latitude?.$error){
			if(!this.$v.location.latitude?.required){
				return 'Coordinates are required.';
			}
			if(this.$v.location.latitude?.$invalid){
				return 'Please enter coordinates in accepted format.';
			}
		}
		return null;
	}

	calculateCoordinates() {
		const invalidAddress = new Alert('Coordinates cannot be calculated. Please add a physical address and try again.', NoticeClass.ERROR);
		
		if (this.address1Error || this.cityError || this.stateError || this.zipError) {
			this.$store.dispatch('notices/add', invalidAddress);
		} else {
			this.loadingCoordinates = true;
			this.geocodeSvc.getGeocoding(
				this.location.address1,
				this.location.address2,
				this.location.city,
				this.location.state,
				this.location.zip
			).then(resp => {
				this.location.latitude = resp.lat;
				this.location.longitude = resp.lng;
				this.$v.location.latitude?.$touch();
				this.$v.location.longitude?.$touch();
			}).catch(() => {
				this.$store.dispatch('notices/add', invalidAddress);
			}).finally(() => {
				this.loadingCoordinates = false;
			})
		}
	}
	
	created() {
		this.locationSvc.findAllBranchImages(this.$route.params.clientId)
			.then(resp => {
				if(resp.data.data.length){
					this.images = resp.data.data;
				}
			})
	}
}
